import {rootReducer} from "./rootReducer"
import {configureStore, Tuple} from "@reduxjs/toolkit"
import {getReduxMiddlewares} from "scholastic-client-components/src/middlewares/reduxMiddlewares"
import {formErrorMiddleware} from "../../../scholastic-client-components/src/middlewares/formErrorMiddleware"

export const store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({serializableCheck: false, immutableCheck: false}).concat(
            new Tuple(...getReduxMiddlewares(), formErrorMiddleware.middleware)
        ),
})
